import { ORM } from 'redux-orm';

import {
  Activity,
  Attachment,
  Board,
  Card,
  Folder,
  Label,
  List,
  Notification,
  Project,
  User,
  UserBoardPreference,
  CardRelation,
  Role,
  RolePermission,
  Permission,
  UserRoleAssignment,
} from './models';

const orm = new ORM({
  stateSelector: (state) => state.orm,
});

orm.register(
  User,
  Project,
  Board,
  Folder,
  Label,
  List,
  Card,
  Attachment,
  Activity,
  Notification,
  UserBoardPreference,
  CardRelation,
  Role,
  RolePermission,
  Permission,
  UserRoleAssignment,
);

export default orm;
